/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Component} from '@angular/core';
import {PageCollectionService} from './providers/page-collection';
export class WizardStepnav {
/**
 * @param {?} pageService
 */
constructor(public pageService: PageCollectionService) {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-wizard-stepnav",
    template: `
        <ol class="clr-wizard-stepnav-list" role="tablist">
            <li *ngFor="let page of pageService.pages" clr-wizard-stepnav-item 
            [page]="page" class="clr-wizard-stepnav-item"></li>
        </ol>
    `,
    host: {"class": "clr-wizard-stepnav"}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: PageCollectionService, },
];
}

function WizardStepnav_tsickle_Closure_declarations() {
/** @type {?} */
WizardStepnav.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardStepnav.ctorParameters;
/** @type {?} */
WizardStepnav.prototype.pageService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
